import Vue from "vue";
import * as moment from "moment";
import { Component, Prop, Watch } from "vue-property-decorator";

import { bootbox } from "../../infrastructure/bootbox-shim";
import { ApiServices } from "../../scripts/ah.mb.model-command-log-services";


@Component
export default class ModelAnnotationsTable extends Vue {

    private commentsTable;

    @Prop()
    value: string;

    @Prop()
    nodePathAndName: string = "";

    @Watch("value")
    valueChanged(newVal) {
        if (newVal)
            this.refreshJobTable();
    }



isVisible: boolean = false;

    beforeRouteLeave(to, from, next) {
        this.isVisible = false;
        next();
    }



    mounted() {


        this.isVisible  = true;

        this.populateTable();
    }


// Refreshes the script list
 refreshJobTable() {

     this.commentsTable.ajax.url(this.getTableAjaxUrl()).load();
}

    getNodePath(): string {
        return this.nodePathAndName;
    }

    getTableAjaxUrl(): string {
        const tableUrl = `/ModelChangeLog/${this.value}/asdatatable`;
        return tableUrl;
    }

    getTableAjax(): DataTables.AjaxSettings {

        const tableUrl = this.getTableAjaxUrl();

    return    {
            url: tableUrl, //"<?php echo base_url('data/ajax'); ?>",
                type: "POST",
                global: false, // Suppress global ajax notification
                data: (data: any) => {
                // Pass "commentsOnly" as true in the request params

                data.nodePath = this.getNodePath();
                data.commentsOnly = true;
                return data;
            }
        };
    }

    /**
 * Delete annotation button click
 */
    deleteAnnotationButtonClick(e) {
        const id = $(e.target).attr("data-objectId");
        const logServices = new ApiServices();
        logServices.deleteAnnotation(this.value, id)
            .then(() => { this.commentsTable.ajax.reload() });

    }

    /**
 * Add annotation button click
 */
    addAnnotationButtonClick() {

        var nodePath = this.getNodePath(); 
        var logServices = new ApiServices();

        bootbox.prompt({
            title: `Add comment about ${nodePath}`,
            callback: (data) => {
                if (data) {
                    logServices.addAnnotation(this.value, nodePath, data)
                        .then(() => {
                            this.commentsTable.ajax.reload();
                        });

                }
            }
        });
    }

    populateTable() {


        //const tableUrl = `/ModelChangeLog/${this.modelId}/asdatatable`;

        if (!this.commentsTable) {

            // Because mvc datatables expects variables in the old format we have to set
            // it to specifically use the old variables, because we are using ajax option below
            //$.fn.dataTable.ext.legacy.ajax = true;

            const columnDefs: DataTables.ColumnSettings[] = [
                {
                    title: "Date",
                    data: "dateExecuted",
                    width: "25%",
                    render: (data) => {
                        var dateStr = data;

                        // Date comes in some non standard format because of datatables
                        // MVC thing
                        var date = moment.utc(dateStr).local().format("dddd, MMMM Do YYYY h:mm a");
                        return date;
                    }
                },
                {
                    title: "User",
                    data: "executingUser",
                    width: "8%"
                },
                {
                    title: "Comment",
                    data: "description",
                //    width: "38%"
                },
                {
                    title: "Options",
                    width: "6%",
                    orderable: false,
                    render: (data, type, oObj) => {
                        return `<button class="btn btn-xs btn-danger delete-annotation-button" data-objectId="${oObj.id}">Delete</button>`;
                    }

                }
            ];

            const ajaxSettings = this.getTableAjax();

            const tableSettings: DataTables.Settings = {
                //"processing": true,
                serverSide: true,
                //            "sAjaxSource": tableUrl,
                //           "sServerMethod": "POST",
                autoWidth: false,
                //pagingType: true, Todo: resolve
                lengthChange: false,
                //isplayLength: 10, Todo: resolve
                pageLength: 5,
                // filter: true, Todo: resolve
                //"stateSave": true,
                order: [[0, "desc"]],
                // sort: true, Todo: resolve
                scrollCollapse: true,
                paging: true,
                searching: true,
                ajax: ajaxSettings,

                //// For 24-cell grid system
                //"dom": "<'row'<'col-sm-12'l><'col-sm-12'f>>" +
                //    "<'row'<'col-sm-24'tr>>" +
                //    "<'row'<'col-sm-10'i><'col-sm-4'p>>",

                // Done drawing callback
                //"fnDrawCallback": function(oSettings) { mainTableDrawCallback(oSettings); },

                // Custom no data message
                language: {
                    "emptyTable": "No log entries found"
                },

                columns: columnDefs,

                // Done drawing callback - attach delete button handlers
                drawCallback: () => {
                    $(".delete-annotation-button").click(this.deleteAnnotationButtonClick);
                }

            };

            this.commentsTable = $("#commentsTable").DataTable(tableSettings);
        } else {
            this.commentsTable.ajax.reload();
        }
    }


}



// WEBPACK FOOTER //
// ./ClientApp/components/model-annotations-table/model-annotations-table.ts